import { useTranslation } from "react-i18next";
import BreadCrumbNavbar from "../../components/BreadCrumbNavbar/BreadCrumbNavbar";
import { useErrorStore } from "../../stores/errors.store";

import { removeQuotesFromString } from "../../utils";
import styles from "./ErrorPage.tsx.module.scss";

export default function ErrorPage() {
  const { t } = useTranslation();
  const { backendError } = useErrorStore();

  return (
    <article className={styles.errorPage}>
      <BreadCrumbNavbar
        returnTo={backendError === t("error.noResultFound") ? "/" : "/recherche"}
        step="none"
      />
      <header>
        <h1>
          {backendError &&
            removeQuotesFromString(JSON.stringify(backendError, null, 2))}
        </h1>
      </header>
      <main>{t("error.noResultFound")}</main>
    </article>
  );
}
